export default {"src":"/_next/static/media/visa.fd2a05e0.svg","height":24,"width":35,"blurWidth":0,"blurHeight":0};